import * as t from 'io-ts';

import type { TextInputDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface RoleSettingDefinition extends TextInputDefinition {
    key: 'ROLE';
}

const definition: RoleSettingDefinition = {
    type: 'TextInput',
    key: 'ROLE',
    label: 'Role',
    value: 'test role',
    changeable: false,
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const RoleSettingDefinition = define({
    key: 'SCALE',
    label: 'scale',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.role),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.role),
});
